import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'On-demand' },
    { value: 2, label: 'Termly' },
    { value: 3, label: 'Annual' },
    { value: 4, label: 'Biannual' },
  ],
});
